import { render, staticRenderFns } from "./CityCRUD.vue?vue&type=template&id=36e20879"
import script from "./CityCRUD.vue?vue&type=script&lang=js"
export * from "./CityCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports